import { useConfig } from "@/context/ConfigContext";
import { useEffect, useState } from "react";

const extractFeaturesArray = (payload) => {
  if (!payload) return [];

  // kemungkinan response langsung array
  if (Array.isArray(payload)) return payload;

  // response umum: { data: [...] }
  if (Array.isArray(payload.data)) return payload.data;

  // response pagination: { data: { data: [...] } }
  if (Array.isArray(payload?.data?.data)) return payload.data.data;

  // response: { data: { features: [...] } }
  if (Array.isArray(payload?.data?.features)) return payload.data.features;
  if (Array.isArray(payload?.features)) return payload.features;

  return [];
};

export function useFeatures(options = {}) {
  const { params = {}, enabled = true } = options;
  const { config, configData } = useConfig();
  const [features, setFeatures] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!enabled || !configData?.team_id || !config?.api?.baseUrl) return;

    let isMounted = true;

    const fetchFeatures = async () => {
      try {
        setLoading(true);
        setError(null);

        const teamId = configData.team_id;
        const queryParams = new URLSearchParams();
        Object.entries(params || {}).forEach(([key, value]) => {
          if (value === undefined || value === null || value === "") return;
          queryParams.append(key, value);
        });

        const qs = queryParams.toString();
        const proxyUrl = `/api/features?team_id=${teamId}${qs ? `&${qs}` : ""}`;

        const fetchJson = async (url) => {
          const response = await fetch(url, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            cache: "no-cache",
          });

          if (!response.ok) {
            let errorText = "";
            try {
              errorText = await response.text();
            } catch {}
            let errorData = null;
            try {
              errorData = errorText ? JSON.parse(errorText) : null;
            } catch {}

            throw new Error(
              errorData?.message ||
                errorData?.error ||
                errorText ||
                "Gagal mengambil data features",
            );
          }

          return response.json();
        };

        const data = await fetchJson(proxyUrl);
        const items = extractFeaturesArray(data);

        if (!isMounted) return;
        setFeatures(items);
      } catch (err) {
        if (!isMounted) return;
        setError(err?.message || "Gagal mengambil data features");
      } finally {
        if (!isMounted) return;
        setLoading(false);
      }
    };

    fetchFeatures();

    return () => {
      isMounted = false;
    };
  }, [enabled, configData?.team_id, config?.api?.baseUrl, JSON.stringify(params)]);

  return { features, loading, error };
}
